@if (hostWidth) {
  <div class="px-2 w-full absolute top-0 left-0 z-[-1] flex gap-1">
    <div class="grow flex flex-col px-6 py-4 gap-6 rounded-radius-container bg-background-container-primary h-[128px]"></div>
  </div>
  <app-loading-skeleton class="shrink-0 w-full h-[128px]" [viewBox]="'0 0 ' + hostWidth + ' 128'">
    <svg:rect x="24" y="16" rx="5" ry="5" width="152px" height="28px" />
    <svg:rect x="24" y="68" rx="5" ry="5" width="80px" height="45px" />
    <svg:rect x="120" y="68" rx="5" ry="5" width="80px" height="45px" />
    <svg:rect x="216" y="68" rx="5" ry="5" width="80px" height="45px" />
    <svg:rect x="312" y="68" rx="5" ry="5" width="80px" height="45px" />
  </app-loading-skeleton>
}
